/**
 * AudioManager - Simple utility for chess sound effects.
 * Uses standard browser Audio API.
 */
class AudioManager {
    private sounds: Record<string, HTMLAudioElement> = {};
    private enabled: boolean = true;

    constructor() {
        if (typeof window !== 'undefined') {
            this.loadSound('move', '/sounds/move.ogg');
            this.loadSound('capture', '/sounds/capture.ogg');
            this.loadSound('check', '/sounds/check.ogg');
            this.loadSound('castle', '/sounds/castle.ogg');
            this.loadSound('promote', '/sounds/promote.ogg');
            this.loadSound('game-end', '/sounds/game-end.ogg');
            // Move classification fallback to standard sounds
            this.loadSound('blunder', '/sounds/game-end.ogg');
            this.loadSound('brilliant', '/sounds/check.ogg');
        }
    }

    private loadSound(name: string, url: string) {
        const audio = new Audio(url);
        audio.preload = 'auto';
        this.sounds[name] = audio;
    }

    public play(name: string) {
        if (!this.enabled || !this.sounds[name]) return;

        const sound = this.sounds[name];
        sound.currentTime = 0;
        sound.play().catch(() => {
            // Browsers often block autoplay until user interaction
            console.warn('AudioManager: Playback failed (interaction required?)');
        });
    }

    public setEnabled(val: boolean) {
        this.enabled = val;
    }

    public isEnabled() {
        return this.enabled;
    }
}

export const audioManager = new AudioManager();
